// .../shared/production/refiner-production-validation.ts

import { isEmpty } from 'psims/lib/empty';
import { UpdateMsoProductionDraft, UpdateMsoProductionField } from 'psims/models/submission-types/mso/annual-activity/refiner/update-mso-production';
import { UseMsoAnnualActivityRefData } from '../use-mso-annual-activity-ref-data';

const MAX_VOLUME = 1000000;

export type ValidationResult =
  | {
      key: UpdateMsoProductionField;
      code: 'invalid_required';
    }
  | {
      key: UpdateMsoProductionField;
      code: 'invalid_integer' | 'invalid_integer_range';
      max: number;
      min: number;
    };

export function validateProduction(
  prod: UpdateMsoProductionDraft,
  refData: UseMsoAnnualActivityRefData
): Array<ValidationResult> {
  const messages: Array<ValidationResult> = [];

  const product = refData.productIdMap[prod.msoProductId];
  if (product?.productStatus === 'inactive') {
    return messages;
  }
  if (isEmpty(prod.totalProductionAnnualVolume)) {
    messages.push({ key: 'totalProductionAnnualVolume', code: 'invalid_required' });
  } else if (
    isNaN(Number(prod.totalProductionAnnualVolume)) ||
    String(prod.totalProductionAnnualVolume).indexOf('.') > -1
  ) {
    messages.push({
      key: 'totalProductionAnnualVolume',
      code: 'invalid_integer',
      max: MAX_VOLUME,
      min: 0,
    });
  } else if (
    Number(prod.totalProductionAnnualVolume) < 0 ||
    Number(prod.totalProductionAnnualVolume) > MAX_VOLUME
  ) {
    messages.push({
      key: 'totalProductionAnnualVolume',
      code: 'invalid_integer_range',
      max: MAX_VOLUME,
      min: 0,
    });
  }

  return messages;
}